module.exports = __webpack_public_path__ + "img/en-logo.1da02aab.svg";